import { useMutation, useQueryClient } from "@tanstack/react-query";
import { App } from "antd";
import { handleError } from "api";
import {
  CreateApprovedDTO,
  WithdrawApiService,
} from "features/withdraw/api/withdraw-api.service";

import { withdrawQueryKeys } from "./query-keys";

const { SuperAdminManualApi } = WithdrawApiService();
export const useSuperAdminManual = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: CreateApprovedDTO) => {
      return SuperAdminManualApi(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (data: any) => {
        if (data?.response_status == 1) {
          message.success(data?.response_message);

          queryClient.invalidateQueries({
            queryKey: withdrawQueryKeys.all,
          });
        } else {
          message.error(data?.response_message);
        }
      },
    }
  );
};
